/** Component that defines the stage in the process, and displays it to the user on the home page.
has triggers to several actions as stages progress, either for the customer or the admin */
import React from 'react';
import { Button, Row, Col, Card } from 'react-bootstrap';
import './stageprogress.css';
import StageManager from '../../services/stageManager';

export default class StageProgress extends React.Component {

    constructor() {
        super();
        this.stageManager = new StageManager();
    }


    render() {
        /** Builds the action handler for a button press (location to go to in router + a state object) */
        let _actionHandler = (actionObj) => {
            this.props.history.push(actionObj.loc, actionObj.state);
        };

        let currentStage = this.props.stage;
        let stagesArray = this.props.stagesArray;
        if(currentStage === undefined){
            currentStage = 0;
        }
        let iconPicker = (index) => {
            if (index === 0) {
                return (<img src="images/firstStage.png" alt="firstStage" />);
            } else if (index === stagesArray.length - 1) {
                return (<img src="images/lastStage.png" alt="lastStage" />);
            } else {
                return (<img src="images/middleStage.png" alt="Stage" />);
            }
        };

        let progressState = (index) => {
            if (index === currentStage) {
                return "doing";
            } else if (index < currentStage) {
                return "done";
            } else {
                return "todo";
            }
        };

        let renderStages = stagesArray.map((stage, index) => {
            return (<div className={"point " + progressState(index)} key={index}>
                <span className={progressState(index)}>
                    {iconPicker(index)}</span> {stage.name}
            </div>);
        });
        let stage = this.stageManager.getStageByIndex(currentStage);
        // this.stageManager.g
        let actionButtons = [];
        if (stage.actions) {
            actionButtons = stage.actions.map((action, index1) => {
                return (<span key={index1}><Button style={{ width: "150px", marginTop: "10px" }} variant={action.variant ? action.variant : 'primary'} onClick={() => { _actionHandler(action.actionObj) }} key={index1}>{action.text}</Button>&nbsp;</span>);
            })
        }
        return (<Row>
            <Col xs={7} className={"stageProgressPoints"}>
                <div style={{ display: 'inline' }}> {renderStages}</div>

            </Col >
            <Col xs={5} style={{ textAlign: "center", }}>
                <Card className="stageCard">
                    <Card.Header>
                        Current stage {currentStage + 1}
                    </Card.Header>
                    <Card.Body>
                        {stage.desc} <br />
                        <div className="actionButtons">{actionButtons}</div>
                    </Card.Body>
                </Card>

            </Col>

        </Row>)
    }
}


// WEBPACK FOOTER //
// ./src/components/stageprogress/StageProgress.js